import { useMemo } from 'react'
import { useToggle } from 'usehooks-ts'

import { FvButton } from '@fv/client-components'

import { FooterBar } from '@/components/FooterBar'
import { useArchiveLoads } from '@/hooks/shipments'

import { HideForVendor, ShipperOnly } from '../auth/HasRole'
import { BatchPrintSlider } from '../batch-print/BatchPrintSlider'
import { useConfirmedShipmentsFlat } from './hooks/useConfirmedShipments'
import { useConfirmedListParams } from './hooks/useShipmentListParams'

type Props = {
  selected: string[]
  onDone: () => void
}
export const BulkShipmentActions = ({ selected, onDone }: Props) => {
  const [isBatchPrintOpen, toggleBatchPrint, setBatchPrintOpen] = useToggle()
  const { archive, isArchiving } = useArchiveLoads('confirmed')
  const shipments = useConfirmedShipmentsFlat()
  const { isArchived } = useConfirmedListParams(shipments)
  const selectedLoads = useMemo(
    () => shipments.filter(s => selected.includes(s.loadId)),
    [shipments, selected],
  )
  const handleArchiveClick = async () => {
    if (
      !window.confirm(
        `Are you sure you want to ${
          isArchived ? 'unarchive' : 'archive'
        } these shipments?`,
      )
    ) {
      return
    }
    await archive({
      loadIds: selected,
      shouldArchive: !isArchived,
    })
    onDone()
  }

  return (
    <HideForVendor>
      <FooterBar jc className="col-span-full row-start-2 gap-x-3">
        <FvButton
          theme="default"
          icon="print"
          disabled={selected.length === 0}
          onClick={toggleBatchPrint}
        >
          Print paperwork
        </FvButton>
        <ShipperOnly permissions={['load-booker']}>
          <FvButton
            theme="default"
            loading={isArchiving}
            icon="archive"
            onClick={handleArchiveClick}
          >
            {isArchived ? `Unarchive` : `Archive`} {selected.length} shipments
          </FvButton>
        </ShipperOnly>
      </FooterBar>

      <BatchPrintSlider
        loads={selectedLoads}
        onClose={deselect => {
          if (deselect) {
            onDone()
          }
          setBatchPrintOpen(false)
        }}
        isOpen={isBatchPrintOpen}
      />
    </HideForVendor>
  )
}
